import type { PageDetailResponse } from "contracts/api/dashboard/page-detail.responses";
import type { ContentFitnessVerificationState } from "contracts/enums/content-fitness";
import { CONTENT_FITNESS_COVERAGE_STATUS } from "contracts/enums/content-fitness";
import { CONTENT_FITNESS_DIMENSIONS } from "contracts/report/content-fitness/dimensions";
import { contentFitnessCanonicalCountForDimension } from "contracts/report/content-fitness/lookups";

export type PageContentFitness = PageDetailResponse["contentFitness"];
export type PageAssessment =
  NonNullable<PageContentFitness>["assessments"][number];

/**
 * Merge the canonical dimension definitions with whatever the response
 * persisted, so all five dimensions always render in catalog order — a
 * dimension without stored data shows as unscored rather than disappearing.
 */
export function pageContentFitnessDimensions(
  contentFitness: PageContentFitness,
) {
  return CONTENT_FITNESS_DIMENSIONS.map((definition) => {
    const stored = contentFitness?.dimensions.find(
      (dimension) => dimension.key === definition.key,
    );
    const assessments =
      contentFitness?.assessments.filter(
        (assessment) => assessment.parentMetricKey === definition.key,
      ) ?? [];
    return {
      ...definition,
      score: stored?.score ?? null,
      coverageStatus:
        stored?.coverageStatus ?? CONTENT_FITNESS_COVERAGE_STATUS.UNSCORED,
      assessedSubcriteria: stored?.assessedSubcriteria ?? 0,
      canonicalSubcriteria:
        stored?.canonicalSubcriteria ??
        contentFitnessCanonicalCountForDimension(definition.key),
      assessments,
    };
  });
}

export function countByVerificationState(
  assessments: PageAssessment[],
  state: ContentFitnessVerificationState,
): number {
  return assessments.filter(
    (assessment) => assessment.verificationState === state,
  ).length;
}
